import {
  AttrField,
  BelongsToField,
  BooleanField,
  HasManyByField,
  NumberField,
  OrmModel,
  StringField,
} from 'vuex-orm-decorators'
import { modelNames } from '@/data/models/types'
import BaseModel from '@/data/models/BaseModel'
import Session from '@/data/models/domain/session/Session'
import SenderSource from '@/data/models/domain/SenderSource'
import type { ScheduledTextParameters } from '@/data/models/domain/types'
import type { ScheduledType } from '@/components/views/scheduled/types'
import ScheduledMessageParameters from '@/data/models/domain/scheduled/ScheduledMessageParameters'
import UserPersonalInfo from '@/data/models/domain/UserPersonalInfo'
import Label from '@/data/models/domain/Label'
import { TmArrayStringField } from '@/data/utils/types'

@OrmModel(modelNames.SCHEDULED_MESSAGE)
export default class ScheduledMessage extends BaseModel {
  @StringField(null)
  public title: string | null

  @StringField()
  public nextSend: string

  @StringField()
  public rrule: string

  @StringField()
  public sessionId: string

  @BelongsToField(Session, 'sessionId')
  public session: Session

  @StringField()
  public parametersId: string

  @BelongsToField(ScheduledMessageParameters, 'parametersId')
  public parameters: ScheduledMessageParameters

  @StringField()
  public summary: string

  @StringField(null)
  public lastOccurrence: string | null

  @StringField()
  public firstOccurrence: string

  @StringField()
  public type: string

  @StringField()
  public timezone: string

  @StringField(null)
  public avatar: string | null

  @NumberField()
  public recipientsCount: number

  @StringField()
  public contactName: string

  @AttrField()
  public textParameters: ScheduledTextParameters

  @BooleanField()
  public completed: boolean

  @StringField()
  public lastSent: string

  @StringField()
  public createdAt: string

  @AttrField()
  public senderSourcePhone: string

  @BelongsToField(SenderSource, 'senderSourcePhone')
  public senderSource: SenderSource

  @StringField()
  public status: ScheduledType

  @StringField()
  public createdById: string

  @BelongsToField(UserPersonalInfo, 'createdById')
  public createdBy: UserPersonalInfo

  @TmArrayStringField()
  public labelIds: string[]

  @HasManyByField(Label, 'labelIds')
  public labels: Label[]
}
